import {
    PROFILE_ERROR,
    GET_PROFILE,
    GET_PROFILE2,
    EDIT_PROFILE2,
    GET_PROFILE3,
    CLEAR_PROFILE,
    LOG_PROFILE,
    EDIT_PROFILE, 
    GET_APPLNS, GET_UPDLIST,
    SET_DBCALL, RESET_DBCALL, SET_LOADING, RESET_LOADING, CLEAR_UPDLIST
  } from '../actions/types';

const initialState = {
    profile: null,
    profile2: null,
    profile3: null,
    logprofile: null,
    loading: true,
    getdb: false,
    loading2: true,
    logloading: false,
    error: {},    
    applnid: null,
    pphoto: null,
    allapplns: [],
    updlist: [],
   
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case EDIT_PROFILE:
        case GET_PROFILE:
            return {
                ...state,
                profile: payload,
                loading: false,
                applnid: payload._aid,
                allapplns: payload._docs,
                pphoto: payload._docs.filter((e) => e.id.toString() === "passport_photo").map((e) => e.durl)[0],
            };

        case GET_UPDLIST:
            return {
                ...state,
                updlist: payload, loading: false
            };

        case CLEAR_UPDLIST:
            return {
                ...state,
                updlist: []
            };

            
    
            case SET_DBCALL:
                return {
                    ...state, getdb: true, loading: true
                };

                case RESET_DBCALL:
                    return {
                        ...state, getdb: false
                    };

                  case SET_LOADING:
                        return {
                            ...state, loading: true
                        };

                case RESET_LOADING:
                    return {
                        ...state, loading: false
                    };
        
            case EDIT_PROFILE2:
                case GET_PROFILE2:
                    return {
                        ...state,
                        profile2: payload,
                        loading2: false,                       
                        loading: false
                    };
                
            case GET_APPLNS:
                return {
                    ...state,
                    allapplns: payload,
                    loading: false                    
                };
    
        case PROFILE_ERROR:
            return {
                ...state,
                error: payload,
                loading: true,
                getdb: false
            };
        
       
        case CLEAR_PROFILE:
            return {
                ...state,
                profile: null,   
                profile2: null,             
                loading: true,
                getdb: false,
                logprofile: null,
                error: null,
                allapplns: null,
                logloading: false,
                profile3: null
                
                //applnid: null              
            };                

        case LOG_PROFILE:
            return {
                ...state,
                logprofile: payload,
                loading: false,
                logloading: true
            };

            case GET_PROFILE3:
                return {
                ...state,
                profile3: payload,
                loading: false,
                // applnid: payload._aid
            };
        
        default: 
            return state;
    };
};